<template>
    <div class="request-record">
        <div class="topBar">
            <div class="opeItem">
                <div class="itemTitle">产品类型</div>
                <el-select v-model="record.productType" placeholder="请选择" clearable @change="searchData">
                    <el-option v-for="item in productList" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="opeItem">
                <div class="itemTitle">产品套餐/型号</div>
                <el-select v-model="record.productModel" placeholder="请选择" clearable @change="searchData">
                    <el-option v-for="item in productModelList" :key="item.label" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="opeItem">
                <el-date-picker class="ml10" v-model="record.dateTime" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="searchData">
                </el-date-picker>
            </div>
            <div class="opeItem">
                <el-input v-model="record.keywords" placeholder="请输入" clearable @clear="searchData"
                    @keyup.enter.native="searchData">
                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;"
                        @click="searchData"></i>
                </el-input>
            </div>
        </div>
        <!--表格-->
        <div class="tableContainer">
            <el-table :data="tableData"
                :header-cell-style="{ background: '#d3d9e1', color: '#4C545D', fontSize: '16px' }"
                :cell-style="{ fontSize: '14px', color: '#333333' }" stripe border>
                <div slot="empty" style="font-size: 16px;text-align: center;color: #333333">
                    暂无数据
                </div>
                <!-- <el-table-column align="center" type="selection"></el-table-column> -->
                <el-table-column align="center" label="序号" width="70">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="产品类型" prop="productType" width="140"></el-table-column>
                <el-table-column align="center" label="产品套餐/型号" prop="productModel" width="150"></el-table-column>
                <el-table-column align="center" label="工程名称" prop="projectName"></el-table-column>
                <el-table-column align="center" label="申请人" prop="applicant" width="100"></el-table-column>
                <el-table-column align="center" label="所属公司" prop="company"></el-table-column>
                <el-table-column align="center" label="申请时间" prop="applyTime" width="160"></el-table-column>
                <el-table-column align="center" label="申请状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus === 2">待审核</div>
                        <div v-if="scope.row.applyStatus === 3">审核通过 <span class="download-update"
                                @click="downloadUpdatePackage">下载升级包</span></div>
                        <div v-if="scope.row.applyStatus === 4">审核驳回</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="240">
                    <template slot-scope="scope">
                        <div class="opeBtn" @click="changeApplyStatus(scope.row)"
                            :class="[2].includes(scope.row.applyStatus) ? 'banUse' : 'canUse'">
                            取消
                        </div>
                        <div class="opeBtn canUse" @click="openDetailDialog(scope.row)">详情</div>
                        <div class="opeBtn" :class="[2, 3].includes(scope.row.applyStatus) ? 'banUse' : 'canUse'">
                            编辑</div>
                        <div class="opeBtn" @click="deleteRecord(row)"
                            :class="[3, 4].includes(scope.row.applyStatus) ? 'banUse' : 'canUse'">
                            删除
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginationContainer">
            <el-pagination style="text-align: center; margin-top: 20px; margin-bottom: 10px;"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[5, 10, 25, 50, 100, 150]" :page-size="pageSize"
                layout="total,sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <SignOrDetailDialog :dialogVisible="dialogVisible" :dialogTitle="'详情'" @closeDialog="closeDialog"
            :rowItem="rowItem" />
    </div>
</template>

<script>
import SignOrDetailDialog from './SignOrDetailDialog.vue';
export default {
    components: {
        SignOrDetailDialog,
    },
    data() {
        return {
            rowItem: {},
            dialogVisible: false,
            record: {
                productType: "",
                productModel: "",
                dateTime: "",
                keywords: "",
            },
            productList: [],
            productModelList: [],
            currentPage: 1,
            pageSize: 5,
            total: 0,
            tableData: [
                { productType: "GMVisual 工作站", productModel: "GMVisual Master(GBMS-MPC005U100)", projectName: "珠海研发大楼", applicant: "李莉莉", company: "珠海格力电器股份有限公司", applyTime: "2022-03-06 10:00:00", applyStatus: 3 },
            ],
        }
    },
    methods: {
        //删除请求记录
        deleteRecord() {

        },
        //下载升级包
        downloadUpdatePackage() {

        },
        async openDetailDialog(row) {
            this.rowItem = row;
            await this.$nextTick();
            this.dialogVisible = true;
        },
        changeApplyStatus(row) {

        },
        closeDialog() {
            this.dialogVisible = false;
        },
        searchData() {
            this.pageSize = 5;
            this.currentPage = 1;
            this.getData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },
        getData() {
            console.log("getData......request record")
            let data = {

            };
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style scoped lang="less">
.download-update {
    color: #31a4ff;
    cursor: pointer;
    margin-left: 10px;
}

.ml10 {
    margin-left: 10px;
}

/*表格按钮样式*/
.opeBtn {
    display: inline-block;
    margin-right: 20px;
}

.banUse {
    color: #bbb9b9 !important;
    cursor: not-allowed !important;
}

.canUse {
    cursor: pointer;
    color: #31A4FF;
}

/*顶部操作栏样式*/
.topBar {
    margin: 10px 14px 10px 0;
    text-align: left;

    .opeItem {
        display: inline-block;
        margin-right: 20px;

        .itemTitle {
            display: inline-block;
            font-size: 16px;
            padding: 0 10px;
        }
    }

    .opeItem:last-child {
        margin-right: 0px;
    }
}
</style>